import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AnModelViewComponent } from './an-model-view/an-model-view.component';
import { AlertsAndNotificationsServiceService } from 'src/app/services/common/alerts-and-notifications-service.service';
import { MessageBoxComponent } from '../message-box/message-box.component';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alerts-and-notifications-summary',
  templateUrl: './alerts-and-notifications-summary.component.html',
  styleUrls: ['./alerts-and-notifications-summary.component.scss']
})
export class AlertsAndNotificationsSummaryComponent implements OnInit {

  columnDefs: any;
  operations: any[];
  tempoperation: any[];
  gridApi: GridApi;
  selectedRow: any;
  rowData: any[];
  hasAddPermission: boolean;
  hasEditPermission: boolean;

  AlertsAndNotifications: UntypedFormGroup;
  OutgoingEmailServers: any[];
  Isoutgoingsmtpconfigured: boolean = false;
  ModuleName:string;
  ModuleId:string;
  ScreenCode:string;

  constructor(
    private fb: UntypedFormBuilder,
    private modalService: NgbModal,
    private anservice: AlertsAndNotificationsServiceService,
    private commonService: CommonService,
    private route:ActivatedRoute
    ) 
    { 
      this.AlertsAndNotifications = this.fb.group({OutgoingSMTP: ["", [Validators.required]],});
    this.ModuleName = route.snapshot.params['code'];

    if (this.ModuleName == 'ist') {
      this.ModuleId = '2';
      this.ScreenCode = '206';
    }
    else if (this.ModuleName == 'eap') {
      this.ModuleId = '5';
      this.ScreenCode = '505';
    }
    else if (this.ModuleName == 'grants') {
      this.ModuleId = '4';
      this.ScreenCode = '405';
    }
  }

  ngOnInit(): void {
    this.getANOutgoingSMTPEmails();
    if(this.ModuleName == 'ist'){
      this.columnDefs= [
        {
          "headerName": "Name",
          "field": "Name"
        },
        {
          "headerName": "Event",
          "field": "ANType"
        },
        {
          "headerName": "#days",
          "field": "EventDays",
          sortable: false,
        },
        {
          "headerName": "Target User",
          "field": "TargetUser",
          sortable: false,
        },
        {
          "headerName": "Status",
          "field": "RecordState"
        }
      ];
    }
    else {
      this.columnDefs = [
        {
          "headerName": "Name",
          "field": "Name"
        },
        {
          "headerName": "Event",
          "field": "ANType"
        },
        {
          "headerName": "#days",
          "field": "EventDays",
          sortable: false,
        },
        {
          "headerName": "Status",
          "field": "RecordState"
        }
      ];
    }


    this.tempoperation = [];
    if (this.commonService.getScreenPermission(this.ScreenCode, "N")) {
      this.hasEditPermission = true;
      this.hasAddPermission = true;
    }

    if (this.commonService.getScreenPermission(this.ScreenCode, "E")) {

      this.hasEditPermission = true;
      this.tempoperation.push({
        "name": "Edit",
        "id": "edit"
      });
    }

    if (this.commonService.getScreenPermission(this.ScreenCode, "V")) {
      this.tempoperation.push({
        "name": "View",
        "id": "View"
      });
    }


    this.operations = this.tempoperation.map(operation => {
      return { name: operation.name, callback: this[operation.id], self: this }
    });

    this.getansummarydata();

  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback(this.anservice);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  getANOutgoingSMTPEmails() {
    this.anservice.getanoutsmtpemails(this.ModuleId).subscribe(result => {
      if (result != null && result != undefined) {
        this.OutgoingEmailServers = result.EmailServers;
        this.OutgoingEmailServers = [{ label: "Select", value: "" }].concat(this.OutgoingEmailServers);
        if (result.IsOutSMTPConfigured) {
          this.Isoutgoingsmtpconfigured = true;
          this.AlertsAndNotifications.controls['OutgoingSMTP'].setValue(result.EmailServerID);
        }
        else{
          this.AlertsAndNotifications.controls['OutgoingSMTP'].setValue("");
        }
      }
    },
      err => {

      });
  }

  configure() {
    if (this.Isoutgoingsmtpconfigured) {
      const Modalref = this.modalService.open(AnModelViewComponent, {
        backdrop: false,
        keyboard: false,
        animation: true,
        windowClass: 'modal-lg right modal-right'
      });
      Modalref.componentInstance.Content = {
        content: { ModuleId: this.ModuleId, OperationType: "Add", AlreadyConfiguredEvents: this.rowData }
      }
      Modalref.result.then(result => {
        this.getansummarydata();
      });
    }
    else {
      this.commonService.ValidationBanner('Please select the Email SMTP');
    }
  }

  SaveOutgoingSMTP() {
    if (this.ValidateForm()) {
      if (!this.AlertsAndNotifications.pristine && this.AlertsAndNotifications.dirty) {
        this.Isoutgoingsmtpconfigured = false;
        this.anservice.SaveOutgoingSMTP(this.ModuleId, this.AlertsAndNotifications.controls['OutgoingSMTP'].value).subscribe(
          result => {
            if (result != null && result != undefined) {
              this.Isoutgoingsmtpconfigured = true;
              if (result.Status) {
                this.commonService.SuccessBanner("Outgoing System Alerts & Notification Email SMTP saved successfully");
              } else {
                this.commonService.ValidationBanner('No changes have been performed');
              }
            }
            else {
              this.commonService.ValidationBanner('Unable to save');
            }
          },
          err => {
            this.commonService.ValidationBanner(err);
          }
        );
      }
      else {
        this.commonService.ValidationBanner('No changes have been performed');
      }
    } else {
      this.Isoutgoingsmtpconfigured = false;
    }
  }

  ValidateForm(): boolean {
    let isValid = true;
    var err: any = [];
    if (!this.AlertsAndNotifications.valid) {
      if (this.AlertsAndNotifications.get('OutgoingSMTP')?.errors?.required) {
        err.push("Please select the Email SMTP.");
      }
      if (err && err.length > 0) {
        this.commonService.ValidationBanner('Please select the Email SMTP');
        isValid = false;
      }
    }
    return isValid;
  }

  getansummarydata(){
    this.anservice.getansummarydata(this.ModuleId).subscribe(result =>{
      if(result != null && result != undefined){
        result.forEach(element => {
          if (element.TargetUser == 'I') {
            element.TargetUser = 'Internal';
          }
          else if (element.TargetUser == 'E') {
            element.TargetUser = 'External';
          }
          else if (element.TargetUser == 'B') {
            element.TargetUser = 'Both';
          }

          element.ANType  = element.ANType == 'NOTIFICATION' ? element.NotificationName : element.AlertName;
          element.RecordState = element.RecordState ? 'Active':'Inactive';
        });

        this.rowData = result;
      }
    });
  }

  edit() {
    const Modalref = this['self'].modalService.open(AnModelViewComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true,

    });
    Modalref.componentInstance.Content = {
      heading: 'Edit',
      content: {
        AlertNotificationID: this['self'].selectedRow['AlertNotificationID'],
        ModuleId: this['self'].ModuleId,
        OperationType: "Edit"
      }
    }

    Modalref.result.then(result => {
      this['self'].getansummarydata();
    })
  }

  View() {
    const Modalref = this['self'].modalService.open(AnModelViewComponent, {
      backdrop: false,
      keyboard: false,

      windowClass: 'modal-lg right modal-right',
      animation: true,

    });
    Modalref.componentInstance.Content = {
      heading: 'View',
      content: {
        AlertNotificationID: this['self'].selectedRow['AlertNotificationID'],
        ModuleId: this['self'].ModuleId,
        OperationType: "View"
      }
    }
    Modalref.result.then(result => {
      this['self'].getansummarydata();
    })
  }

   onRowDoubleClicked($event)
   {

  }

}
